import React from "react";
import {
  Button,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Paper,
  Grid,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Skeleton from "@material-ui/lab/Skeleton";
import AddBoxIcon from "@material-ui/icons/Add";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
//import EditIcon from "@material-ui/icons/Edit";
import DialogCreateEvent from "../Dialogs/DialogAddNewDoc";
import toastType from "../../../API/CallUtils/tostyNotification";
import SportEvent from "../../../API/SportEvent";
import MUIDataTable from "mui-datatables";
import LinkIcon from "@material-ui/icons/Link";
const styles = (theme) => ({
  paper: {
    //height: "85vh",
    width: "100%",
    //padding: "1%",
  },
  Grid: {
    width: "100%",
    height: "100%",
  },
  Table: {
    width: "100%",
    //padding: "1%",
  },
  Margin: {
    margin: "5px",
    padding: "5px",
  },
  AddCandidate: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(99, 159, 191,0.2)",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgb(30, 160, 230)",
    "&:hover": {
      backgroundColor: "rgb(99, 159, 191,0.5)",
    },
  },
  ImgPre: {
    width: "150px",
    height: "150px",
    objectFit: "contain",
    display: "block",
  },
});

class addCandidateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ListEvents: [],
      EventId: null,
      onError: false,
      onLoad: true,
      GallerieName: "",
    };
  }
  componentDidMount = async () => {
    this.fetchlist();
  };
  fetchlist = async () => {
    try {
      this.setState({
        onLoad: true,
      });

      const Deli = await SportEvent.DocumentsShowAll(this.props.EventId);
      //console.log("Documentos del deporte", Deli);
      if (Deli.status === "success") {
        const List = Deli.data.documents.map((iteam) => {
          return [
            iteam.url.split("/")[4].split(".")[0],
            iteam.url.split("/")[4].split(".")[1],
            iteam.SportEventDocumentType.name,
            iteam.createdAt.split("T")[0],
            <Button
              color="primary"
              variant="contained"
              href={iteam.url}
              className={this.props.btn}
            >
              <LinkIcon />
            </Button>,
            <Button
              color="secondary"
              variant="contained"
              onClick={this.delete.bind(this, iteam.id, iteam.name)}
              className={this.props.btn}
            >
              <DeleteIcon />
            </Button>,
          ];
        });
        console.log(List);
        this.setState({
          ListEvents: List,
          onLoad: false,
        });
      } else {
        toastType.error("Error");
        this.setState({
          onError: true,
          onLoad: false,
          ErrorCase: "SSE No fue Posible Eliminar el elemento",
        });
      }
    } catch (e) {
      toastType.error("CSE No fue posible Borrar el evento");
      console.log(e);
      this.setState({
        onErrorFetch: true,
        onLoad: false,
        ErrorCase: "Error en la llamada de los recursos",
      });
    }
  };
  delete = async (id) => {
    try {
      this.setState({
        onLoad: true,
      });

      const Deli = await SportEvent.DocumentsDelete(id);
      console.log(Deli);
      if (Deli.status === "success") {
        toastType.success("Se borro con éxito");
        await this.fetchlist();
      } else {
        toastType.error("Error");
        this.setState({
          onError: true,
          onLoad: false,
          ErrorCase: "SSE No fue Posible Eliminar el elemento",
        });
      }
    } catch (e) {
      toastType.error("CSE No fue posible Borrar el evento");
      console.log(e);
      this.setState({
        onErrorFetch: true,
        onLoad: false,
        ErrorCase: "Error en la llamada de los recursos",
      });
    }
  };
  Dialog = (a, id, name) => {
    this.setState({
      [a]: !this.state[a],
      EventId: id ? id : null,
    });
  };
  Refresh = async (a) => {
    await this.fetchlist();
    this.Dialog(a);
  };
  render() {
    const { classes } = this.props;
    const columns = [
      "Nombre",
      "Tipo",
      "Categoría",
      "Fecha",
      "Documento",
      "Eliminar",
    ];

    const options = {
      textLabels: {
        body: {
          noMatch: "Estableciendo conexión",
          toolTip: "Ordenar",
          columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
        },
        pagination: {
          next: "Siguiente pagina",
          previous: "Pagina anterior",
          rowsPerPage: "Columnas por pagina:",
          displayRows: "de",
        },
        toolbar: {
          search: "Buscar",
          downloadCsv: "Descargar CSV",
          print: "Imprimir",
          viewColumns: "Ver columnas",
          filterTable: "Filtrar tablas",
        },
        filter: {
          all: "Todos",
          title: "FILTROS",
          reset: "RESET",
        },
        viewColumns: {
          title: "Mostrar Columnas",
          titleAria: "Mostrar/Ocultar Columnas de la tabla",
        },
        selectedRows: {
          text: "fila(s) seleccionadas",
          delete: "Borrar",
          deleteAria: "Borrar Filas seleccionadas",
        },
      },
      filterType: "textField",
      page: 0,
      selectableRows: "none",
      print: false,
      rowsPerPage: 100,
      rowsPerPageOptions: [10, 50, 100, 200],
    };
    if (this.state.onLoad) {
      return (
        <Dialog
          open={this.props.DialogOpen}
          onClose={this.props.DialogClose}
          //maxWidth="xl"
        >
          <DialogTitle id="form-dialog-title">Detalles</DialogTitle>
          <DialogContent className={classes.paper}>
            <Skeleton
              variant="rect"
              animation="wave"
              className={classes.Skeleton}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.DialogClose} color="secondary">
              <CloseIcon />
            </Button>
          </DialogActions>
        </Dialog>
      );
    } else if (this.state.onError) {
      return (
        <Dialog
          open={this.props.DialogOpen}
          onClose={this.props.DialogClose}
          maxWidth="xl"
        >
          <DialogTitle id="form-dialog-title">Detalles</DialogTitle>
          <DialogContent className={classes.paper}>
            <Paper className={classes.NoItemPaper}>
              <Typography variant="body1" color="textPrimary" component="p">
                Error
              </Typography>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.DialogClose} color="secondary">
              <CloseIcon />
            </Button>
          </DialogActions>
        </Dialog>
      );
    } else {
      return (
        <Dialog
          open={this.props.DialogOpen}
          onClose={this.props.DialogClose}
          maxWidth="xl"
        >
          <DialogTitle id="form-dialog-title">Detalles</DialogTitle>
          <DialogContent className={classes.paper}>
            <div className={classes.paper}>
              {this.state.ListEvents.length > 0 ? (
                <div className={classes.Table}>
                  <MUIDataTable
                    title={"Listado de documentos"}
                    data={this.state.ListEvents}
                    columns={columns}
                    options={options}
                    selectableRows="none"
                  />
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                    className={classes.Margin}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.Dialog.bind(this, "CreateDialog")}
                    >
                      <AddIcon />
                    </Button>
                  </Grid>
                  {this.state.CreateDialog
                    ? [
                        <DialogCreateEvent
                          DialogOpen={this.state.CreateDialog}
                          DialogClose={this.Dialog.bind(this, "CreateDialog")}
                          Refresh={this.Refresh}
                          id={this.props.EventId}
                        />,
                      ]
                    : [<></>]}
                </div>
              ) : (
                <Paper className={classes.NoItemPaper}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={this.Dialog.bind(this, "CreateDialog")}
                    className={classes.AddCandidate}
                  >
                    <AddBoxIcon />
                  </Button>
                  {this.state.CreateDialog
                    ? [
                        <DialogCreateEvent
                          DialogOpen={this.state.CreateDialog}
                          DialogClose={this.Dialog.bind(this, "CreateDialog")}
                          Refresh={this.Refresh}
                          id={this.props.EventId}
                        />,
                      ]
                    : [<></>]}
                </Paper>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.DialogClose} color="secondary">
              <CloseIcon />
            </Button>
          </DialogActions>
        </Dialog>
      );
    }
  }
}

export default withStyles(styles)(addCandidateDialog);
